module.exports = __webpack_public_path__ + "static/media/caret-circle-right.2d602916.svg";